import ConfirmBox,{openConfirm} from './ConfirmBox';

export default ConfirmBox;

export {
    ConfirmBox,
    openConfirm
};